import { TApplicationState } from 'shared/types/redux';
import { ISeoLink } from '../../types/newbuilding/seoLink';

export const seoLinksSelector = (state: TApplicationState): ISeoLink[] => {
  return state.newbuilding.seoLinks;
};
